<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">NAV Reset</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-correction-line-filter providerJsonPath="providerId" (search)="onSearch($event)" (clear)="onClear()"></ppl-correction-line-filter>
                    <p><strong>Note:</strong></p>
                    <ul>
                        <li>Lists lines that have been sent to NAV.</li>
                        <li><strong>Reset</strong> deletes the selected lines' NAV data so they can be marked Good To
                            Pay or Denied again.</li>
                    </ul>
                </div>
                <div class="table-style">
                    @if (hasSearched) {
                    <ppl-list-table [cols]="cols" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="lines" [customDataLoaded]="true" [enableActions]="false"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" (onPageLoad)="onPageLoad($event)"
                        [actionButtons]="actionButtons" [enablePageActions]="!isReadOnly"
                        [listButton]="isReadOnly ? [] : buttons" (actionInvoked)="gridAction($event)">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning">Search by Provider PPL ID or Participant PPL ID to see lines.</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ppl-correction-notes-dialog [(visible)]="showResetPopup" title="NAV Reset" okText="Reset"
    [message]="'The NAV data for ' + selectedLines.length + ' selected line(s) will be deleted. This cannot be undone.'"
    placeholder="Reason for resetting the NAV data" (confirmed)="submitReset($event)">
</ppl-correction-notes-dialog>
